import { render, staticRenderFns } from "./NoteSimple.vue?vue&type=template&id=677d3882&scoped=true"
import script from "./NoteSimple.vue?vue&type=script&lang=js"
export * from "./NoteSimple.vue?vue&type=script&lang=js"
import style0 from "./NoteSimple.vue?vue&type=style&index=0&id=677d3882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d3882",
  null
  
)

export default component.exports